import { render, staticRenderFns } from "./ExportListForSchool.vue?vue&type=template&id=a585cece&scoped=true&"
import script from "./ExportListForSchool.vue?vue&type=script&lang=js&"
export * from "./ExportListForSchool.vue?vue&type=script&lang=js&"
import style0 from "./ExportListForSchool.vue?vue&type=style&index=0&id=a585cece&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a585cece",
  null
  
)

export default component.exports